import React from 'react';
import { Button, Card, CardBody } from 'reactstrap';
import { RibbonSpecimenProvenances } from '../../constant';
import { TableStriped } from '../../components/tables/TableStriped';
import { ModalSpecimens } from '../../components/specimens/ModalSpecimens';
import { useSpecimenProvenances } from '../../hooks/specimenProvenances/useSpecimenProvenances';
import { ModalSpecimenProvenances } from '../../components/specimenProvenances/ModalSpecimenProvenances';
import { AlertDataTable } from '../../components/tableDataTable/AlertDataTable';
import { TitleDataTable } from '../../components/tableDataTable/TitleDataTable';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

export const IndexSpecimenProvenances = ({activeTab}) => {

    const {
        specimenProvenances, method,
        name, abbreviation,
        handleInputChange, validaciones,
        closeDialog, modal, modalTitle, loading,
        handleCreate, saveCreate,
        handleUpdate, saveUpdate,
        handleDelete, saveDelete,
        closeDeleteAlert, modalAlert, showDeleteAlert,
        loadingExcel, handleExcelProvenanceSpecimen,
        handleSearchProvenacesSpecimen,
        handleClearProvenancesSpecimen,
        searchSpecimenProvenances

    } = useSpecimenProvenances({activeTab});

    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "11px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
    };

    const actions = (rowData) => {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ gap: "3px", marginRight: "3px" }}>
                <Button
                    size="sm"
                    onClick={() => handleUpdate(rowData.id_specimen_provenance)}
                    title="Editar"
                    className="btnTableAction"
                >
                    <i className="fa fa-edit iconTableAction"></i>
                </Button>


                <button
                    onClick={() => handleDelete(rowData.id_specimen_provenance)}
                    title="Eliminar"
                    className="btnTableAction"
                    style={{
                        backgroundColor: "#bf0d0d"
                    }}
                >
                    <i className="fa fa-trash"></i>
                </button>
            </div>
        );
    };

    return (
        <>
            <Card>
                <CardBody className="p-1 mt-2">
                    <TitleDataTable
                        titleTable="Listado de procedencias de especímen"
                        buttonActions={handleExcelProvenanceSpecimen}
                        titleButton="Listado de procedencias de especimen"
                        isDisbled={loadingExcel}
                        loadingIsDisabled={loadingExcel}
                        titleCreate="Crear procedencia de especimen"
                        buttonActionsCreate={handleCreate}
                        actionInput={handleSearchProvenacesSpecimen}
                        valueFilter={searchSpecimenProvenances}
                        filterLocalStorage={true}
                        cleanFilterLocalStorage={handleClearProvenancesSpecimen}
                    />
                                
                    <div className="table-responsive">
                        <DataTable
                            value={specimenProvenances}
                            paginator
                            rows={15}
                            responsiveLayout="scroll"
                            rowsPerPageOptions={[15, 50, 100]} 
                            className="data-table p-datatable-striped p-datatable-sm"
                            emptyMessage={
                                <div className="text-center">
                                    <img
                                        src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                        style={{ width: "32%" }}
                                        alt="Sin resultados"
                                    />
                                    <br />
                                    <p className="badge badge-light-primary mt-2" style={{ fontSize: "15px" }}>
                                        No se encontraron resultados.
                                    </p>
                                </div>
                            }
                        >

                            <Column header="#" body={(rowData, options) => { const globalIndex = options.rowIndex; return globalIndex + 1; }} headerStyle={headerStyle} style={centerStyle} />
                            <Column field="name" header="Nombre" headerStyle={headerStyle} style={cellStyle} />
                            <Column field="abbreviation" header="Abreviatura" headerStyle={headerStyle} style={cellStyle} />
                            <Column header="Acciones" body={actions} exportable={false} headerStyle={headerStyle} style={centerStyle} />
                        </DataTable>
                    </div>
                  
                </CardBody>
            </Card>

            {showDeleteAlert && (
                <AlertDataTable
                    titleAlert="Eliminar procedencias del especímen"
                    visibleAlert={modalAlert}
                    onHideAlert={closeDeleteAlert}
                    sizeAlert="medium-dialog delete-method"
                    messageAlert="Esta acción no se puede deshacer. ¿Estás seguro de eliminar la procedencia del especímen:?"
                    alert1={true}
                    titleAlert1={name}
                    buttonAcept
                    titleNotLoading="Eliminar"
                    titleDanger="Cancelar"
                    actionAcept={saveDelete}
                />

            )}

            <ModalSpecimenProvenances
                {
                    ...{
                        modal, modalTitle, closeDialog, method, loading,
                        name, abbreviation, handleInputChange,
                        validaciones, saveCreate, saveUpdate, saveDelete
                    }
                }
            />
        </>
    )
}
